// extracted by mini-css-extract-plugin
export default {"inputFile":"ImageConverter_inputFile__TGkIM","buttonWepb":"ImageConverter_buttonWepb__Qq9iQ"};